<template>
  <div class="app-container" id="yhsUpload">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="100px"
        style="display: flex"
      >
        <el-form-item label="分公司：" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="选择分公司"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <div class="star">*</div>
        <el-form-item label="项目名称：" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="选择导出项目"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 300px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="统计月份：" prop="tjyf">
          <el-date-picker
            ref="tjyf"
            v-model="listQuery.tjyf"
            type="month"
            placeholder="选择统计月份"
            value-format="yyyyMM"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; display: flex">
          <div>
            <el-button
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="handleExport"
              style="margin-left: 15px"
              >下载模板</el-button
            >
          </div>
          <div class="upload">
            <el-upload
              class="upload"
              ref="upload"
              action="#"
              :on-exceed="handleExceed"
              :on-change="handleChange"
              :file-list="fileList"
              :show-file-list="false"
              :headers="headers"
              :auto-upload="false"
              multiple
              :limit="1"
            >
              <el-button size="small" type="primary">导入文件</el-button>
            </el-upload>
          </div>
          <!-- <div>
              <el-button
              size="small"
              type="primary"
              @click="importData"
              v-if="scqk == 1"
              style="margin-left: 15px;"
              >确定</el-button
            >
           </div> -->
        </span>
      </el-form>
    </div>
    <el-descriptions direction="vertical" border>
      <el-descriptions-item
        label-class-name="my-label"
        content-class-name="my-content"
        label="注意事项"
      >
        1、下载模板时，请先选择项目(可多选)，再点击下载模板；
        2、行员类型只能填“全行员、行领导、一把手”其中一种；</el-descriptions-item
      >
    </el-descriptions>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          v-if="is_upload"
          label="上传情况"
          align="left"
          fixed
          prop="scqk"
          min-width="300px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="分公司"
          align="left"
          prop="bmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目名称"
          align="left"
          prop="xmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="统计月份"
          align="left"
          prop="tjyf"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="行员类型"
          align="left"
          prop="hylx"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="当期考核人数"
          align="left"
          prop="dqkhrs"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="行员总人数"
          align="right"
          prop="hyzrs"
          min-width="150px"
          :show-overflow-tooltip="true"
          header-align="center"
        />

        <el-table-column label="活跃用户数" align="center">
          <el-table-column
            label="总活跃用户数"
            align="left"
            prop="zhyyhs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="PC端活跃用户数"
            align="left"
            prop="pchyyhs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="移动端活跃用户数"
            align="left"
            prop="ydhyyhs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
        </el-table-column>
        <el-table-column label="总使用次数" align="center">
          <el-table-column
            label="当月登录操作总次数"
            align="left"
            prop="drczzcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="所有操作总次数"
            align="left"
            prop="syczzcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
        </el-table-column>
        <el-table-column label="PC端" align="center">
          <el-table-column
            label="当月登录操作次数"
            align="left"
            prop="pcdrczcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="所有操作次数"
            align="left"
            prop="pcsyczcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
        </el-table-column>
        <el-table-column label="移动端" align="center">
          <el-table-column
            label="当月登录操作次数"
            align="left"
            prop="yddrczcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="所有操作次数"
            align="left"
            prop="ydsyczcs"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
        </el-table-column>
        <el-table-column
          label="录入理由"
          align="left"
          prop="reason"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
      </el-table>
      <pagination
        v-if="!is_upload"
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { getBmxxList, getXmxxList } from "@/api/itWeekly";
import {
  hyyhsDownload,
  hyyhsLogList,
  hyyhsUpload,
  importHyyhs,
} from "@/api/jxcp.js";
export default {
  // 列表分页
  components: {
    Pagination,
  },

  data() {
    return {
      action: window.g.apiUrl + "pmp/jxcp/hyyhsUpload",
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "DS,MC,PX,RW,SD,SW,TS,DS,SW,YP", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "1", //合同状态，多个,隔开，如1,3
      },
      height: 100,
      listQuery: {
        bmbh: "",
        xmbh: "",
        tjyf: moment().format("YYYYMM"),
        page: 1,
        pageSize: 10,
      },
      listLoading: false,
      total: 0,
      list: [],
      bmList: [],
      xmList: [],
      fileList: [],
      is_upload: false,
      scqk: null,
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "task"]),
  },
  created() {
    getBmxxList(this.data2.type, this.data2.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      this.listQuery.bmbh,
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });

    this.getList();
  },

  methods: {
    getList() {
      const params = { ...this.listQuery };
      hyyhsLogList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 125;
        }
      });
    },

    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      getXmxxList(
        this.data2.htlx,
        this.data2.range,
        this.data2.htzt,
        i,
        "1,2,3"
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    //导出
    handleExport() {
      const bmbh = this.listQuery.bmbh;
      const xmbh = this.listQuery.xmbh.join(",");
      const tjyf = this.listQuery.tjyf;
      const params = { bmbh, xmbh, tjyf };
      hyyhsDownload(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    handleChange(file, fileList) {
      const suffixReg = /(xls|xlsx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }

      // 验证文件大小
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //   this.$refs.upload.submit();
      let { uploadFiles } = this.$refs.upload;
      let form = new FormData();
      uploadFiles.forEach((item, index) => {
        form.append("file", item.raw);
      });
      this.step = 1;
      hyyhsUpload(form).then((res) => {
        if (res.code == 0) {
          // this.$message.success("上传成功！");
          this.fileList = [];
          this.list = res.data.list;
          this.scqk = res.data.scqk;
          this.is_upload = true;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 30;
          if (this.scqk == 1) {
            this.importData();
          }
        } else {
          this.fileList = [];
          this.$message({
            type: "error",
            message: res.msg,
            showClose: true,
          });
        }
      });
    },

    importData() {
      importHyyhs().then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.fileList = [];
          this.scqk = null;
          setTimeout(() => {
            this.step = 0;
          }, 3000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    // 重置
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          txlx: null,
          name: null,
          sun: null,
          status: null,
          ygbh: null,
          title: null,
          rlr: null,
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
.upload {
  margin-left: 5px;
}
.star {
  line-height: 40px;
  color: red;
  margin-right: -15px;
  margin-left: 15px;
}
</style>
